module.exports = __webpack_public_path__ + "static/media/civic.9af88f2a.jpg";